<template>
    <div id="app">
        <div class="ui-top-fix" id="top-fix">
            <header class="ui-nav-panel">
                <div class="ui-nav-center">
                    <div class="ui-top-content">
                        <div class="ui-logo fn-left">
                            <a href="/" title="杭州博胜">
                                <img src="static/images/home/10.png" alt="" title="">
                            </a>
                        </div>
                        <nav class="ui-nav fn-left">
                            <ul>
                                <li class="ui-nav-box">
                                    <router-link to='/Home' class="ui-nav-1">
                                        首页
                                        <p>HOME</p>
                                    </router-link>
                                </li>
                                <li class="ui-nav-box">
                                    <router-link to='/About' class="ui-nav-1">
                                        二手手机
                                        <p>phone</p>
                                    </router-link>
                                </li>
                                <li class="ui-nav-box">
                                    <router-link to='/homeland' class="ui-nav-1">
                                        二手电脑
                                        <p>computer</p>
                                    </router-link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div class="barright2">
                    <router-link to='/release' class="ui-nav-1">
                        <span>发布信息</span>
                    </router-link>
                </div>
                <div class="barright" v-if="account!=undefined">
                    <span>{{account}}</span>
                </div>
                <div class="barright" v-else>
                    <router-link to='/register' class="ui-nav-1">
                        <span>注册</span>
                    </router-link>
                    <span>/</span>
                    <router-link to='/logion' class="ui-nav-1">
                        <span>登录</span>
                    </router-link>
                </div>
            </header>
        </div>
        <div class="container">
            <router-view />
        </div>
        <footer>
            <div class="ui-footer">
                <div class="ui-footer-content">
                    <p class="ui-ft-2">版权所有：杭州博胜网络科技有限公司</p>
                    <p class="ui-ft-2">地址：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备20016903号</a></p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            account: "",
        };
    },
    mounted() {
        this.account = sessionStorage.getItem("account");
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
.router-link-active {
    color: #ff0101;
}
.container {
    min-height: calc(100vh - 64px) !important;
    width: 100%;
    margin: 0 auto;
    background: white;
}
.ui-nav-center {
    height: 65px;
    // background: url(~static/images/home/nav_bg.png) top no-repeat;
    background-color: #ff4800c0;
}
.ui-telphone {
    display: block;
    background: url(~static/images/home/16.png) no-repeat;
    background-size: 100%;
    width: 230px;
    height: 46px;
    margin-top: 11px;
}
a:link {
    color: #a7a7a7;
    text-decoration: none;
}
a:visited {
    color: #585656;
    text-decoration: none;
}
a:hover {
    color: white;
    text-decoration: underline;
}
a:active {
    color: #a7a7a7;
    text-decoration: none;
}
.router-link-active {
    color: white !important;
    text-decoration: none;
}
.router-link-active p {
    color: white !important;
}
.ui-top-content {
    width: 485px;
    margin-left: 20%;
}
.ui-footer {
    background-color: rgb(17, 17, 17) !important;
    padding-bottom: 10px;
}
.ui-ft-2 {
    color: white !important;
}
.barright {
    position: absolute;
    top: 20px;
    right: 20%;
    span {
        cursor: pointer;
        color: white;
    }
}
.barright2 {
    position: absolute;
    top: 20px;
    right: 30%;
    span {
        cursor: pointer;
        color: white;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue